export enum serviceTypeEnum {
    PREPAID = "PREPAGO",
    POSTPAID = "POSPAGO",
    PENDING = "PENDIENTE"
}

export const serviceStateEnum = {
    ACTIVE: "ACTIVO",
    APPROVED: "APROBADO",
    CANCELLED: "CANCELADO",
    COMPLETED: "COMPLETADO",
    DECLINED: "RECHAZADO",
    ERROR: "ERROR",
    IN_PROGRESS: "EN CURSO",
    INACTIVE: "INACTIVO",
    INSTALLING: "INSTALACION EN CURSO",
    INSTALLPAYED: "PENDIENTE DE INSTALACION",
    INSTALLED: "INSTALADO",
    NEWPLAN: "NUEVO PLAN",
    NOIDPAYMENT: "NO HAY PLAN SELECCIONADO",
    PAID: "PAGADO",
    PENDING: "PENDIENTE",
    SUSPENDED: "SUSPENDIDO",
    TERMINATED: "TERMINADO",
    WAITFORPLAN: "PENDIENTE DE ASIGNAR PLAN",
    RETIRED: "RETIRADO"
} as const;

export type ServiceStateType = typeof serviceStateEnum[keyof typeof serviceStateEnum];


export enum serviceInstallState {
    INSTALLING = "INSTALACION EN CURSO",
    INSTALLPAYED = "PENDIENTE DE INSTALACION",
    INSTALLED = "INSTALADO",
    PAID = "PAGADO",
    IN_PROGRESS = "EN CURSO",
    COMPLETED = "COMPLETADO",
    PENDING = "PENDIENTE"
}
